export default __webpack_public_path__ + "static/media/slide-Vikkymore-Foundation.a5110983.png";